import { Spine } from "@esotericsoftware/spine-pixi-v8";
import gsap from "gsap";
import {
    BitmapText,
    Container, Graphics,
    Point,
    Sprite,
} from 'pixi.js';

import {
    getSpineSymbol,
    getSymbol
} from "../../config/getSymbol";

import { betValueGlobal, isDoubleReelFeature, RespinIndex } from "../../config/GlobalVariableConfig";
import {
    DOUBLE_REEL_GAP,
    HOLDSPIN_REEL_DIVIDER,
    HOLDSPIN_REEL_WIDTH,
    HOLDSPIN_ROW_DIVIDER,
    HOLDSPIN_SYMBOL_HEIGHT,
    HOLDSPIN_SYMBOL_WIDTH,
    REEL_FRAME,
    REEL_NUMBERS,
    SYMBOL_IDS,
    SYMBOLS_PER_REEL,
    SYMBOLS_PER_REEL_DOUBLE
} from "../../config/reelConfig";

import { spinData } from "../../server/getServerResposesFun";

import { sound } from "@pixi/sound";
import { EventEmitter } from "pixi.js";
import { WinMeterComponent } from "../../components/winmeters/WinMeterComponent";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";
import { DisplayComponent } from "../displays/DisplayComponent";

export const holdAndSpinEmitter = new EventEmitter();

export let SYMBOLS_PER_REEL_FEATURE: number = 0;

export const BLANK_SYM_ID = 23;

export interface CellObject {
    view: Container;
    symbolId: number;
    symbol: Sprite;
    coinVal: number;
    coinValText: BitmapText;
}

export interface SymbolObject {
    view: Container;
    cells: CellObject[];
    isWin: boolean;
    IdxCellOffView: number;
}

export interface ReelObject {
    container: Container;
    reelIndex: number;
    symbols: SymbolObject[];
}

export interface reelOverlayObject {
    view: Container;
    symbolId: number | null;
    symbol: Spine | null;
    coinVal: number | null;
    coinValText: BitmapText | null;
    coinValFinalText: BitmapText | null;
    multVal: number | null;
    multValText: BitmapText | null;
}

export class ReelInit extends Container {

    public allReelArray: ReelObject[];

    public reelOverlayContainer: Container;
    public reelOverlaySymbols: reelOverlayObject[][] = [];
    public reelOverlaySymbolAnticipation: Spine[][] = [];

    public anticipation: Spine[];

    private allReelContainer: Container;

    public spinLeftMeter: Spine;
    public winCollectionMeter: Spine;

    public totalWinVal: number = 0;
    public totalWinText: BitmapText;

    // Debounce flag to prevent rapid-fire panel collect animation collisions
    private _panelCollectPending: boolean = false;

    public prevReelSymbols: number[][];
    public prevReelCoinValues: number[][];

    public anticipationTopLayer: Container;

    constructor() {
        super();

        this.allReelContainer = new Container();
        this.allReelContainer.label = "allReelContainer";

        this.allReelArray = [];

        this.reelOverlayContainer = new Container();
        this.reelOverlayContainer.label = "reelOverlayContainer";

        this.anticipation = [];
        this.initReels();
    }

    private initReels(): void {

        SYMBOLS_PER_REEL_FEATURE = isDoubleReelFeature ? SYMBOLS_PER_REEL_DOUBLE : SYMBOLS_PER_REEL;

        this.prevReelSymbols = Array.from({ length: REEL_NUMBERS }, () =>
            Array(SYMBOLS_PER_REEL_FEATURE).fill(BLANK_SYM_ID)
        );

        this.prevReelCoinValues = Array.from({ length: REEL_NUMBERS }, () =>
            Array(SYMBOLS_PER_REEL_FEATURE).fill(0)
        );

        const triggerReelSymbols = spinData.respins[RespinIndex.value - 2].reelSymbols;
        const triggerCoinValues = spinData.respins[RespinIndex.value - 2].coinValues;

        for (let row = 0; row < triggerReelSymbols.length; row++) {
            for (let col = 0; col < triggerReelSymbols[row].length; col++) {
                const symbol = triggerReelSymbols[row][col];
                if (symbol >= 13 && symbol <= 15) {
                    this.prevReelSymbols[row][col] = symbol;
                }
                this.prevReelCoinValues[row][col] = triggerCoinValues[row][col];
            }
        }

        for (let i = 0; i < REEL_NUMBERS; i++) {
            const reelContainer = new Container();
            reelContainer.label = "reelCont";

            const reelObj: ReelObject = {
                container: reelContainer,
                reelIndex: i,
                symbols: [],
            };

            reelContainer.x = REEL_FRAME + i * (HOLDSPIN_REEL_WIDTH + HOLDSPIN_REEL_DIVIDER);
            reelContainer.y = REEL_FRAME;

            for (let j = 0; j < SYMBOLS_PER_REEL_FEATURE; j++) {
                const symbolContainer = new Container();
                symbolContainer.label = "symbolContainer";
                const IdxCellOffView = 1;
                const cells: CellObject[] = [];

                for (let k = 0; k < 2; k++) {
                    const view = new Container();
                    view.label = "symbolView";

                    const symbolId = this.prevReelSymbols[i][j];
                    const symbol = Sprite.from(getSymbol(symbolId));
                    symbol.anchor.set(0.5);
                    view.addChild(symbol);

                    const coinVal = this.prevReelCoinValues[i][j];
                    const coinValText = new BitmapText({
                        text: "",
                        style: {
                            fontFamily: "3God_coin",
                            fontSize: 30,
                            // letterSpacing: 3,
                        }
                    });
                    coinValText.anchor.set(0.5);
                    view.addChild(coinValText);

                    if (k === IdxCellOffView) {
                        view.y -= HOLDSPIN_SYMBOL_HEIGHT;
                    }

                    cells.push({ view, symbolId, symbol, coinVal, coinValText });
                    symbolContainer.addChild(view);
                }

                symbolContainer.x = REEL_FRAME + Math.round(HOLDSPIN_SYMBOL_WIDTH / 2);
                symbolContainer.y = REEL_FRAME + Math.round(HOLDSPIN_SYMBOL_HEIGHT / 2)
                    + j * (HOLDSPIN_SYMBOL_HEIGHT + HOLDSPIN_ROW_DIVIDER);

                const cellMask = new Graphics()
                    .rect(-HOLDSPIN_SYMBOL_WIDTH / 2, -HOLDSPIN_SYMBOL_HEIGHT / 2, HOLDSPIN_SYMBOL_WIDTH, HOLDSPIN_SYMBOL_HEIGHT)
                    .fill(0xffffff);
                cellMask.label = "cellMask";
                cellMask.alpha = 0.5;
                symbolContainer.addChild(cellMask);
                symbolContainer.mask = cellMask;

                const symbolObj: SymbolObject = {
                    view: symbolContainer,
                    cells,
                    isWin: false,
                    IdxCellOffView,
                };

                reelObj.symbols.push(symbolObj);
                reelContainer.addChild(symbolContainer);
            }

            this.allReelArray.push(reelObj);
            this.allReelContainer.addChild(reelContainer);
        }

        const doubleReelExtragap = SYMBOLS_PER_REEL_FEATURE > 3 ? DOUBLE_REEL_GAP : 0;
        const reelMask = new Graphics()
            .rect(
                REEL_FRAME, REEL_FRAME,
                HOLDSPIN_REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * HOLDSPIN_REEL_DIVIDER,
                HOLDSPIN_SYMBOL_HEIGHT * SYMBOLS_PER_REEL_FEATURE
                + (SYMBOLS_PER_REEL_FEATURE - 1) * HOLDSPIN_ROW_DIVIDER
                + doubleReelExtragap
            )
            .fill(0x950a5a);
        reelMask.label = "reelMask";
        reelMask.alpha = 0.5;

        this.allReelContainer.addChild(reelMask);
        this.allReelContainer.mask = reelMask;
        this.addChild(this.allReelContainer);

        this.reelOverlayContainer.destroy();
        this.initReelOverlayContainer();
        this.setupSpinLeftMeter();
        this.setupWinCollectionMeter();
        this.setupTotalWin();
    }

    // ─────────────────────────────────────────────────────────────────────────
    // METERS
    // ─────────────────────────────────────────────────────────────────────────

    private setupSpinLeftMeter(): void {
        this.spinLeftMeter = Spine.from({
            skeleton: "spinLeftSkel",
            atlas: "spinLeftAtlas",
        });
        this.spinLeftMeter.label = "spinLeftMeter";
        this.spinLeftMeter.position.set(500, 755);
        this.spinLeftMeter.scale = isDoubleReelFeature ? 1.2 : 1;
        this.spinLeftMeter.visible = false;
        this.addChild(this.spinLeftMeter);
    }

    private setupWinCollectionMeter(): void {
        this.winCollectionMeter = Spine.from({
            skeleton: "collectionPannelSkel",
            atlas: "collectionPannelAtlas",
        });
        this.winCollectionMeter.label = "winCollectionMeter";
        this.winCollectionMeter.position.set(500, 753);
        this.winCollectionMeter.scale = 0.6;
        this.winCollectionMeter.visible = false;
        this.addChild(this.winCollectionMeter);

        this.winCollectionMeter.state.addListener({
            complete: (entry: any) => {
                if (
                    entry.animation.name === "digital_pannel_appear" ||
                    entry.animation.name === "digital_pannel_collect"
                ) {
                    this.winCollectionMeter.state.setAnimation(0, "digital_pannel_loop", true);
                    // Allow the next collect hit to trigger the animation again
                    this._panelCollectPending = false;
                }
            }
        });
    }

    private setupTotalWin(): void {
        this.totalWinVal = 0;
        this.totalWinText = new BitmapText({
            text: '',
            style: { fontFamily: "3God_coin", trim: true, fontSize: 50 }
        });
        this.totalWinText.anchor.set(0.5, 0.3);
        this.winCollectionMeter.addSlotObject("amount", this.totalWinText);
    }

    // ─────────────────────────────────────────────────────────────────────────
    // OVERLAY CONTAINER
    // ─────────────────────────────────────────────────────────────────────────

    public initReelOverlayContainer(): void {
        this.reelOverlayContainer = new Container();
        this.reelOverlayContainer.x = this.allReelContainer.x;
        this.reelOverlayContainer.y = this.allReelContainer.y;
        this.addChild(this.reelOverlayContainer);

        this.anticipationTopLayer = new Container();
        this.anticipationTopLayer.label = "anticipationTopLayer";
        this.addChild(this.anticipationTopLayer);

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {

            if (!this.reelOverlaySymbols[reelNum]) {
                this.reelOverlaySymbols[reelNum] = [];
            }

            for (let posNum = 0; posNum < SYMBOLS_PER_REEL_FEATURE; posNum++) {

                const view = new Container();

                const overlayObj: reelOverlayObject = {
                    view,
                    symbolId: null,
                    symbol: null,
                    coinVal: null,
                    coinValText: null,
                    coinValFinalText: null,
                    multVal: null,
                    multValText: null,
                };

                const symbolContainer = this.allReelArray[reelNum].symbols[posNum].view;
                const globalPos = symbolContainer.getGlobalPosition();
                const localPos = this.allReelContainer.toLocal(globalPos);

                view.x = localPos.x;
                view.y = localPos.y;
                view.label = `${reelNum * SYMBOLS_PER_REEL_FEATURE + posNum}`;
                this.reelOverlayContainer.addChild(view);

                // Anticipation spine per cell
                const anticipation = Spine.from({
                    skeleton: "symbolAnticipationSkel",
                    atlas: "symbolAnticipationAtlas",
                });
                anticipation.label = `symbolAnticipation_${reelNum}_${posNum}`;
                anticipation.visible = false;
                anticipation.alpha = 0;
                // anticipation.position.set(0, 0);
                anticipation.position.set(
                    view.x + this.reelOverlayContainer.x,
                    view.y + this.reelOverlayContainer.y
                );

                this.anticipationTopLayer.addChild(anticipation);

                if (!this.reelOverlaySymbolAnticipation[reelNum]) {
                    this.reelOverlaySymbolAnticipation[reelNum] = [];
                }
                this.reelOverlaySymbolAnticipation[reelNum][posNum] = anticipation;
                this.reelOverlaySymbols[reelNum][posNum] = overlayObj;
            }
        }

        // Pre-populate carry-forward symbols
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL_FEATURE; posNum++) {
                if (this.prevReelSymbols[reelNum][posNum] !== BLANK_SYM_ID) {
                    this.addReelSymbolsToContainer(reelNum, posNum, true);
                }
            }
        }
    }

    // ─────────────────────────────────────────────────────────────────────────
    // ANTICIPATION
    // ─────────────────────────────────────────────────────────────────────────

    public playSymbolAnticipation(reelNum: number, posNum: number): void {
        const anticipation = this.reelOverlaySymbolAnticipation?.[reelNum]?.[posNum];
        if (!anticipation || anticipation.visible) return;

        anticipation.visible = true;
        anticipation.alpha = 1;
        anticipation.state.setAnimation(0, "animation", true);
        sound.play(SoundConstants.ANTICIPATION_SOUND, { volume: 1 });
    }

    public stopSymbolAnticipation(reelNum: number, posNum: number): void {
        const anticipation = this.reelOverlaySymbolAnticipation?.[reelNum]?.[posNum];
        if (!anticipation || !anticipation.visible) return;

        anticipation.state.setEmptyAnimation(0, 0);
        anticipation.visible = false;
        anticipation.alpha = 0;
        anticipation.state.clearListeners();
    }

    public stopAllSymbolAnticipation(): void {
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL_FEATURE; posNum++) {
                this.stopSymbolAnticipation(reelNum, posNum);
            }
        }
    }

    // ─────────────────────────────────────────────────────────────────────────
    // CARRY-FORWARD COINS
    // ─────────────────────────────────────────────────────────────────────────

    public addCarryForwardCoins(): void {
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL_FEATURE; posNum++) {
                if (this.prevReelSymbols[reelNum][posNum] !== BLANK_SYM_ID) {
                    const coinVal = this.getValue(reelNum, posNum);
                    const winMeterComponent = DisplayComponent.get(WinMeterComponent).getInstance();
                    winMeterComponent.setupMeter(reelNum, posNum, coinVal);
                    winMeterComponent.revealMultiplier(
                        `${reelNum}_${posNum}`,
                        coinVal,
                        this.reelOverlaySymbols[reelNum][posNum].symbol
                    );
                }
            }
        }
    }

    // ─────────────────────────────────────────────────────────────────────────
    // ADD SYMBOL TO OVERLAY
    // ─────────────────────────────────────────────────────────────────────────

    public addReelSymbolsToContainer(reelNum: number, posNum: number, isCalledFromInit: boolean = false): void {

        // Guard: don't add twice
        if (this.reelOverlaySymbols[reelNum][posNum].symbol != null) return;

        // Hide the backing sprite so the Spine overlay is the only thing visible
        this.allReelArray[reelNum].symbols[posNum].view.alpha = 0;

        const IdxCellInView = 1 - this.allReelArray[reelNum].symbols[posNum].IdxCellOffView;
        const symbolIdFromBase = this.allReelArray[reelNum].symbols[posNum].cells[IdxCellInView].symbolId;

        let symbolId: number;
        if (isCalledFromInit) {
            symbolId = (symbolIdFromBase >= 13 && symbolIdFromBase <= 15) ? 22 : symbolIdFromBase;
        } else {
            if (symbolIdFromBase === 13 || symbolIdFromBase === 16 || symbolIdFromBase === 17 || symbolIdFromBase === 24) symbolId = 13;
            else if (symbolIdFromBase === 14 || symbolIdFromBase === 18 || symbolIdFromBase === 19 || symbolIdFromBase === 25) symbolId = 14;
            else if (symbolIdFromBase === 15 || symbolIdFromBase === 20 || symbolIdFromBase === 21 || symbolIdFromBase === 26) symbolId = 15;
            else symbolId = symbolIdFromBase;
        }

        const coinVal = isCalledFromInit
            ? this.getValue(reelNum, posNum)
            : this.allReelArray[reelNum].symbols[posNum].cells[IdxCellInView].coinVal;

        const symbol = getSpineSymbol(symbolId);

        const coinValText = new BitmapText({
            text: `${coinVal}x`,
            style: { fontFamily: "3God_coin", fontSize: 30 }
        });

        const reelOverlaySymbolView = this.reelOverlaySymbols[reelNum][posNum].view;

        // Populate overlay object
        this.reelOverlaySymbols[reelNum][posNum].symbolId = symbolId;
        this.reelOverlaySymbols[reelNum][posNum].symbol = symbol;
        this.reelOverlaySymbols[reelNum][posNum].coinVal = coinVal;
        this.reelOverlaySymbols[reelNum][posNum].coinValText = coinValText;
        this.reelOverlaySymbols[reelNum][posNum].coinValFinalText = coinValText;

        reelOverlaySymbolView.addChild(symbol);

        // Coin value text wrapper (placed into the Spine "multiplier" slot)
        const textWrapper = new Container();
        coinValText.anchor.set(0.5);
        coinValText.scale = Math.min(120 / coinValText.width, 1);
        textWrapper.addChild(coinValText);

        if (symbolId === SYMBOL_IDS.Gold_Coin) {
            symbol.addSlotObject("multiplier", textWrapper);
        }

        if (symbolIdFromBase === SYMBOL_IDS.Gold_Coin) {
            const winMeterComponent = DisplayComponent.get(WinMeterComponent).getInstance();
            winMeterComponent.setupMeter(reelNum, posNum, coinVal);
            winMeterComponent.revealMultiplier(`${reelNum}_${posNum}`, coinVal, symbol);
        }

        if (!isCalledFromInit) {
            sound.play('coin_appear_sound', { volume: 1 });
        }

        // Kick off entry animation
        if (symbolId === SYMBOL_IDS.Gold_Coin) {
            symbol.state.setAnimation(0, "appear", false).listener = {
                complete: () => {
                    symbol.state.setAnimation(0, "idle", true);
                    symbol.state.clearListeners();
                }
            };
        } else {
            symbol.state.setAnimation(0, "land", false);
            console.log("Available animations:");
            symbol.skeleton.data.animations.forEach((a) => console.log(a));
        }
    }

    // ─────────────────────────────────────────────────────────────────────────
    // MULTIPLIER HIT
    // ─────────────────────────────────────────────────────────────────────────

    public addMultToCoinInContainer(reelNum: number, posNum: number, multValue: number): Promise<void> {
        return new Promise<void>((resolve) => {

            const reelSymbol = this.reelOverlaySymbols[reelNum][posNum];
            if (!reelSymbol.symbol) { resolve(); return; }

            const reelSymbolSpine = reelSymbol.symbol;
            const reelSymbolView = reelSymbol.view;

            const multiplierTrail = Spine.from({
                skeleton: "bonusCoinTrailSkel",
                atlas: "bonusCoinTrailAtlas",
            });
            multiplierTrail.label = "multiplierTrail";
            reelSymbolView.addChild(multiplierTrail);

            multiplierTrail.state.setAnimation(0, "bonus_coin_trail", false).listener = {
                complete: () => {
                    sound.play("multiplier_hit", { volume: 1 });

                    reelSymbolSpine.state.setAnimation(0, "multiplier_land_effect", false).listener = {
                        complete: () => {
                            reelSymbolSpine.state.setAnimation(0, "multipler_idle", true);
                            reelSymbolSpine.state.clearListeners();
                        }
                    };

                    reelSymbol.multVal = multValue;

                    const multValTextBitmap = new BitmapText({
                        text: "",
                        style: { fontFamily: "3God_coin", fontSize: 30, letterSpacing: 5 }
                    });

                    const multValText = reelSymbol.multValText ?? multValTextBitmap;
                    multValText.text = `${multValue}x`;
                    multValText.anchor.set(0.5);
                    reelSymbolSpine.addSlotObject("multiplier", multValText);
                    reelSymbol.multValText = multValText;

                    multiplierTrail.state.clearListeners();
                    reelSymbolView.removeChild(multiplierTrail);
                    multiplierTrail.destroy();

                    resolve();
                }
            };
        });
    }

    // ─────────────────────────────────────────────────────────────────────────
    // COIN VALUE TEXT UPDATE
    // ─────────────────────────────────────────────────────────────────────────

    public animateCoinValueUpdate(text: BitmapText, _fromValue: number, toValue: number): Promise<void> {
        return new Promise<void>((resolve) => {
            text.text = `${toValue}x`;
            resolve();
        });
    }

    // ─────────────────────────────────────────────────────────────────────────
    // COLLECT COIN TO PANEL  (replaces trail logic)
    // ─────────────────────────────────────────────────────────────────────────

    public collectCoinToPanel(reelNum: number, posNum: number, addValue: number): Promise<void> {
        return new Promise<void>((resolve) => {

            const overlayObj = this.reelOverlaySymbols?.[reelNum]?.[posNum];
            if (!overlayObj || overlayObj.coinVal == null) { resolve(); return; }

            // Top-level container for flying clone — prefer the scene root so
            // coordinates don't get offset by reel/overlay containers.
            const topLayer = (this.parent as Container | null) ?? this;

            // ── Start position: use the overlay view's world position.
            // getBounds() is unreliable for text inside a Spine slot, so we
            // anchor to the view container instead (centre of the symbol cell).
            const startGlobal = overlayObj.view.getGlobalPosition();
            const startLocal = topLayer.toLocal(startGlobal);

            // ── End position: total-win text inside winCollectionMeter slot.
            // Fall back to the meter's own position if the slot hasn't rendered yet.
            let endLocal: Point;
            try {
                const endBounds = this.totalWinText.getBounds();
                if (endBounds.width > 0) {
                    endLocal = topLayer.toLocal(
                        new Point(endBounds.x + endBounds.width / 2, endBounds.y + endBounds.height / 2)
                    );
                } else {
                    throw new Error("zero-size bounds");
                }
            } catch {
                const meterGlobal = this.winCollectionMeter.getGlobalPosition();
                endLocal = topLayer.toLocal(meterGlobal);
            }

            // ── Clone text that will fly to the meter
            const originalText = overlayObj.coinValText;
            const flyText = new BitmapText({
                text: `${addValue}x`,
                style: { fontFamily: "3God_coin", fontSize: 30 }
            });
            flyText.anchor.set(0.5);
            flyText.position.set(startLocal.x, startLocal.y);
            if (originalText) {
                flyText.scale.set(originalText.scale.x, originalText.scale.y);
                // Hide source text during flight to avoid visual duplication
                originalText.alpha = 0;
            }
            topLayer.addChild(flyText);

            // Stagger slightly by grid position so coins don't all launch at once
            // const baseDelay = reelNum * 0.08 + posNum * 0.04;

            // Tactile "punch" on launch
            sound.play(SoundConstants.FINAL_MULTIPLIERS_COLLECT,{ volume: 0.7 });
            gsap.fromTo(
                flyText.scale,
                { x: flyText.scale.x * 0.8, y: flyText.scale.y * 0.8 },
                { x: flyText.scale.x * 1.15, y: flyText.scale.y * 1.15, duration: 0.12, yoyo: true, repeat: 1 }
            );

            // Arc via a raised midpoint
            const midX = (startLocal.x + endLocal.x) / 2;
            const midY = Math.min(startLocal.y, endLocal.y) - 140;

            gsap.timeline()
                .to(flyText, { x: midX, y: midY, duration: 0.25, ease: "power2.out" })
                .to(flyText, { x: endLocal.x, y: endLocal.y, alpha: 0, duration: 0.35, ease: "power2.inOut" }, "<")
                .eventCallback("onComplete", () => {

                    // Update running total
                    this.totalWinVal = Math.min(this.totalWinVal + addValue, 10_000);
                    this.totalWinText.text = (this.totalWinVal * betValueGlobal).toFixed(2);
                    while(this.totalWinText.width > 400){
                        this.totalWinText.style.fontSize -= 1;
                    }
                    // Debounced panel collect animation — prevents rapid-fire
                    // state collisions when many coins land at near the same time.
                    if (!this._panelCollectPending) {
                        this._panelCollectPending = true;
                        this.winCollectionMeter.state.setAnimation(0, "digital_pannel_collect", false);
                        // _panelCollectPending is reset in the meter's complete listener (setupWinCollectionMeter)
                    }

                    flyText.destroy();
                    resolve();
                });
        });
    }

    // ─────────────────────────────────────────────────────────────────────────
    // HELPERS
    // ─────────────────────────────────────────────────────────────────────────

    private getValue(reelNum: number, posNum: number): number {
        const coins = spinData.respins[0].transformCoins;
        const result = coins.find(c => c.reelNum === reelNum && c.posNum === posNum);
        return result?.value ?? 0;
    }
}